import { api, extractData } from '@/lib/treaty';

export const checkTokenExistence = async (id: string) => {
  const token = await extractData(api['invite-tokens']({ id }).get());

  return token.exists;
};
